<template>
<el-card shadow="never" class="aui-card--fill">
  <el-form :inline="true" :model="dataForm">
    <el-form-item>
      <el-select v-model="dataForm.agentId" filterable remote clearable :remote-method="searchAgents" :loading="agentLoading" placeholder="请输入代理用户名" style="width: 260px;">
      <el-option v-for="agent in agentOptions" :key="agent.id" :label="agentLabel(agent)" :value="agent.id"/></el-select>
    </el-form-item>
    <el-form-item>
      <el-select v-model="dataForm.payType" placeholder="收款方式" clearable>
        <el-option label="支付宝" :value="1"/><el-option label="微信" :value="2"/>
        <el-option label="银行卡" :value="3"/>
        <el-option label="USDT" :value="4"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-select v-model="dataForm.status" placeholder="状态" clearable>
        <el-option label="启用" :value="1"/><el-option label="禁用" :value="2"/>
      </el-select>
    </el-form-item>
    <el-form-item>
        <el-button @click="search">查询</el-button>
    </el-form-item>
  </el-form>
  <el-table v-loading="loading" :data="dataList" border>
    <el-table-column prop="id" label="ID" width="80"/>
    <el-table-column label="代理账号" min-width="150">
      <template slot-scope="scope">
        <div class="agent-account">{{ scope.row.agent_username || '-' }}</div>
        <div class="agent-nickname">{{ scope.row.agent_nickname || '-' }}</div>
      </template>
      </el-table-column>
    <el-table-column label="收款方式"><template slot-scope="s">{{ payTypeText(s.row.payType) }}</template></el-table-column>
    <el-table-column prop="remarkName" label="备注名称"/><el-table-column prop="account" label="收款账号"/>
    <el-table-column prop="realName" label="收款人"/><el-table-column prop="bankName" label="开户行"/>
    <el-table-column prop="bankBranch" label="支行"/><el-table-column prop="usdtChain" label="USDT链"/><el-table-column label="状态"><template slot-scope="s"><el-tag :type="statusType(s.row.status)">{{ statusText(s.row.status) }}</el-tag></template></el-table-column><el-table-column prop="createTime" label="创建时间" width="180"/></el-table><el-pagination :current-page="page" :page-size="limit" :total="total" :page-sizes="[10,20,50,100]" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange" @current-change="currentChange"/>
</el-card>
</template>
<script>
import agentPage from '@/mixins/agent-page'

export default {
  mixins: [agentPage],
  data () {
    return {
      pageUrl: '/agent-receipt/page',
      dataForm: {
        agentId: '',
        payType: '',
        status: ''
      },
      agentLoading: false,
      agentOptions: []
    }
  },
  methods: {
    searchAgents (username) {
      const keyword = username.trim()
      if (!keyword) {
        this.agentOptions = []
        return
      }

      this.agentLoading = true
      this.$http.get('/agent/page', {
        params: {
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.agentOptions = []
          return this.$message.error(data.msg)
        }
        this.agentOptions = data.data.list || []
      }).finally(() => {
        this.agentLoading = false
      })
    },
    agentLabel (agent) {
      const nickname = agent.nickname ? ` - ${agent.nickname}` : ''
      return `${agent.username}${nickname}（ID: ${agent.id}）`
    }
  }
}
</script>
